import React from 'react';

/**
 * REQUIREMENT 3: Preview Domain Visual Safety Banner
 * Displays warning banner on preview environments.
 */
const PreviewBanner = () => {
  // Check if we're on a preview domain
  const isPreview = window.location.hostname.includes('preview.emergentagent.com') ||
                    window.location.hostname.includes('localhost') ||
                    window.location.hostname.includes('127.0.0.1');
  
  if (!isPreview) return null;
  
  const productionUrl = 'https://80yearsofconnection.com';
  
  return (
    <div
      data-testid="preview-warning-banner"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100001,
        background: 'linear-gradient(90deg, #ff4444, #cc0000)',
        color: 'white',
        padding: '12px 20px',
        textAlign: 'center',
        fontFamily: 'Arial, sans-serif',
        fontWeight: 'bold',
        fontSize: '14px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
      }}
    >
      <span style={{ marginRight: '15px' }}>
        ⚠️ PREVIEW ENVIRONMENT – DO NOT USE FOR REAL REGISTRATIONS ⚠️
      </span>
      <a
        href={productionUrl}
        data-testid="production-link"
        style={{
          color: 'white',
          textDecoration: 'underline',
          marginLeft: '10px',
          background: 'rgba(0,0,0,0.2)',
          padding: '5px 12px',
          borderRadius: '4px',
        }}
      >
        Go to Production Site →
      </a>
    </div>
  );
};

export default PreviewBanner;
